import React from "react";
import { connect } from "react-redux";
import "./styles.scss";
import _ from "lodash";
import { indexTop10Artists } from "../../../../api/users";
import { indexMedia } from "../../../../api/media";
import FullPageSpinner from "../../../FullPageSpinner";
import ResultComponent from "../QueryResults/ResultComponent";
import { watch, abstractString } from "../../../../api/helper";

import genres from "../../../../public/genres.json";
const images = require.context(`../../../../public/FINAL/`, false, /.*\.png$/);
const imagePath = (name) => images("./" + name, true);
const genres_details = genres.map((genre) => ({
  name: genre["name"],
  title: genre["name"],
  url: imagePath(genre["img"]),
}));

class WhatsHot extends React.Component {
  state = { media: null, users: null, selectedGenre: null };
  componentDidMount = () => {
    this.fetchData();
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (watch(prevState, this.state, "selectedGenre")) this.fetchData();
  };
  fetchData = async () => {
    this.setState({ media: null, users: null });
    let filter = this.state.selectedGenre ? { tags: [this.state.selectedGenre.name] } : {};
    let {
      data: { users },
    } = await indexTop10Artists(this.state.selectedGenre?.name);
    let {
      data: { media },
    } = await indexMedia({
      page_size: 10,
      filter: { ...filter, type: "SoundTrack" },
      sort: "-play_count",
    });
    this.setState({ media, users });
  };
  selectGenre = (genre) =>
    this.setState({
      selectedGenre: genre === this.state.selectedGenre ? null : genre,
    });
  render() {
    let generesList = [];
    let { current_user } = this.props;
    const musicInterests = current_user?.music_interests;
    if (current_user && musicInterests && musicInterests.length) {
      generesList = genres_details.filter((genre) => musicInterests.map((i) => abstractString(i)).includes(abstractString(genre.name)));
    }
    if (generesList.length === 0) generesList = genres_details;
    generesList = generesList.sort((a, b) => {
      var nameA = a.name.toLowerCase(),
        nameB = b.name.toLowerCase();
      if (nameA < nameB)
        //sort string ascending
        return -1;
      if (nameA > nameB) return 1;
      return 0; //default return value (no sorting)
    });
    return (
      <div id="whats-hot" className="d-flex flex-column empty-search-query">
        <h1 className="m-0">Now Charting on UNIFI Music</h1>
        <small className="text-muted">based on genres you like</small>
        <div className="d-flex overflow-x-scroll mt-3 mb-5">
          {generesList.map((genre) => (
            <div
              onClick={() => this.selectGenre(genre)}
              className={`genre rounded ${this.state.selectedGenre === genre ? "active" : ""}`}
              style={{
                backgroundImage: `url(${genre.url.default})`,
              }}
            >
              <h5 className="text-white py-5">{genre.title}</h5>
            </div>
          ))}
        </div>
        {_.isNull(this.state.users) || _.isNull(this.state.media) ? (
          <FullPageSpinner />
        ) : (
          <div>
            <ResultComponent id="top10-artists" className="my-2 mb-5" label="top 10 artists" items={this.state.users} />
            <ResultComponent id="top10-songs" className="my-2" label="top 10 songs" items={this.state.media} />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { current_user } = state;
  return { current_user };
}
export default connect(mapStateToProps)(WhatsHot);
